module.exports = __webpack_public_path__ + "static/scale-model-of-arizona-state-museum-in-tucson-arizona-6992a7cdb361a2e640c8ffb0f79bb000.png";